import { useUILogic } from '../../shared/providers/UILogicProvider/hooks';
import { ThemeId } from '../../../infrastructure/types/features/themes/theme-types';

function useAppTheme() {
  const { uiRoot } = useUILogic();

  const changeTheme = (themeID: ThemeId) => uiRoot.changeTheme?.(themeID);
  const theme = uiRoot.theme;

  return { theme, changeTheme };
}

export { useAppTheme };
